import React, { useState, useEffect } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import Linesales from "./Linesales";
import axios from "axios";
import { Chart } from "react-google-charts";
import {
  ChevronRight,
  Copy,
  CircleCheckBig,
  SquareCheckBig,
  StickyNote,
  SquareChartGantt,
  NotebookPen,
  Users,
} from "lucide-react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import ChartDashboard from "./ChartDashboard";
import { BarChart } from "./BarChart";
import LineChart from "./LineChart";
import SalesDiscountComboChart from "./Discountsaleschart";
import SalesVsAverageChart from "./SaleAveragechart";
import SpeedCompositionChartWithCalculations from "./Speedmetricsbreakdownchart"
import DailyAverageSpeedChart from "./Averagespeed";
import CostAnalysisChart from "./Costanalysticdashboard";
import EmployeeKpiScorecards from "./Employeedashboard";
import EmployeeHoursTrendChart from "./Employeehourschart";
import EmployeePerformanceDashboard from "./EmployeePerformanceDashboard"


// Timeline chart data (for the line chart)
const timelineData = [
  ["Project", "Task", "Start Date", "End Date"],
  ["Project A", "Planning", new Date(2025, 0, 5), new Date(2025, 0, 20)],
  ["Project B", "Development", new Date(2025, 0, 15), new Date(2025, 1, 10)],
  ["Project C", "Testing", new Date(2025, 1, 5), new Date(2025, 1, 25)],
  ["Project D", "Deployment", new Date(2025, 2, 1), new Date(2025, 2, 15)],
  ["Project E", "Maintenance", new Date(2025, 2, 10), new Date(2025, 2, 31)],
  ["Project F", "Maintenance", new Date(2025, 1, 10), new Date(2025, 2, 31)],
  ["Project G", "Maintenance", new Date(2025, 1, 10), new Date(2025, 2, 31)],
];

const Dashboard = () => {
  const [filter, setFilter] = useState("last_30_days");
  const [status, setStatus] = useState({
    Completed: 10,
    InProgress: 20,
    Requested: 5,
    Rejected: 10,

  });
  const [pendingTask, setPendingTask] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [data, setData] = useState([]); // Fixed: useState, not useEffect
  const [filteredData, setFilteredData] = useState([]);
  const [searchData, setSearchData] = useState(""); // Default empty string
  const [date, setDate] = useState(new Date());

  const [storedetails, setStoredetails] = useState([])
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const mail = user?.email_id;


  console.log("Mail:", mail);

  //   const handleFilterChange = (selectedFilter) => {
  //     setFilter(selectedFilter);
  //     console.log("Selected Filter:", selectedFilter);
  //     fetchStatus(selectedFilter);
  //   };

  //   const fetchStatus = async (selectedFilter) => {
  //     console.log("Fetching status with filter:", selectedFilter);
  //     try {
  //       setLoading(true);
  //       const response = await axios.get("/server/Dashboard/status", {
  //         params: { filter: selectedFilter },
  //       });
  //       const statusData = response.data;
  //       console.log("Status Data:", statusData);
  //       const Pending =
  //         parseInt(statusData.Progress || 0) +
  //         parseInt(statusData.Requested || 0);
  //       setPendingTask(Pending);
  //       setStatus(statusData);
  //     } catch (error) {
  //       console.error("Error fetching status:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  // Fetch enquiry data and merge with user data


  // Search filter logic
  useEffect(() => {
    if (!Array.isArray(data)) return;
    const filtered = data.filter((item) =>
      item.enquiry_status?.toLowerCase().includes(searchData.toLowerCase())
    );
    setFilteredData(filtered);

    var d = new Date(1382086394000);
    console.log("first", d)


  }, [searchData, data]);

  const data1 = [
    ["cash paid", "per day"],
    ["Inprogress", 11],
    ["closed", 2],
    ["open", 2],

  ];

  const options1 = {

    pieHole: 0.9,
    is3D: true,
    // slices: {
    //   1: { offset: 0.2 }, // Explodes the second slice
    // },
    pieStartAngle: 100, // Rotates the chart
    sliceVisibilityThreshold: 0.02, // Hides slices smaller than 2%
    legend: {
      position: "bottom",
      alignment: "center",
      textStyle: {
        color: "#233238",
        fontSize: 14,
      },
    },
    colors: ["#F8D66D", "#7ABD7E", "#9369A9", "#7ABD7E", "#F8D66D"],
  };


  const dashboardData = [
    {
      title: "In Progress",
      count: "10",
      color: "text-[#D15D69]",
      icon: <SquareChartGantt size={30} />,
    },
    {
      title: "Completed",
      count: "250",
      color: "text-[#9369A9]",
      icon: <SquareCheckBig size={30} />,
    },
    {
      title: "Requested",
      count: 15,
      color: "text-[#787878]",

      icon: <NotebookPen size={30} />,
    },
    {
      title: "Rejected",
      count: 350,
      color: "text-[#D15D69]",
      icon: <StickyNote size={30} />,
    },

  ]

  const customDays = [
    {
      title: "Count of Trucks",
      count: 43,
      color: "text-[#E25D25]",
      icon: <CircleCheckBig size={30} />,
    },
    {
      title: "Count of Invoices",
      count: 25014,
      color: "text-[#504F4E]",
      icon: <CircleCheckBig size={30} />,
    }
  ]
  useEffect(() => {
    const date = new Date();
    const day = date.getDay();
    if (day === 2) {
      setStoredetails([...dashboardData, ...customDays]);
    } else {
      setStoredetails(dashboardData);
    }
  }, []);


  return (
    <div className="flex flex-col md:flex-row">
      <div className="p-8 pt-3 w-full">
        {loading ? (
          <div className="flex justify-center items-center h-full">
            <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-gray-500 border-solid"></div>
          </div>
        ) : (
          <>
            {/* Header Section */}
            <div className="flex justify-between items-center">
              <h1 className="text-[30px] font-semibold font-arial">
                Dashboard
              </h1>

              {/* <div className="relative">
                <select
                  className="py-1 px-1 bg-[#F7F7F7] cursor-pointer hover:bg-white rounded-md transition outline-none"
                  // onChange={(e) => handleFilterChange(e.target.value)}
                  value={filter}
                >
                  <option value="last_30_days">Last 30 days</option>
                  <option value="this_month">This Month</option>
                  <option value="this_quarter">This Quarter</option>
                  <option value="this_year">This Year</option>
                  <option value="last_month">Last Month</option>
                  <option value="last_quarter">Last Quarter</option>
                  <option value="last_year">Last Year</option>
                </select>
              </div> */}
            </div>

            {/* Cards Section */}
            {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10 mt-6 ">
              {
                storedetails.map((card, index) => (
                  <div
                    key={index}
                    className="block max-w-sm p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg ms-auto me-auto w-full"
                  >
                    <div className="flex justify-between">
                      <div className="flex p-3 gap-3">
                        {/* <p className={`border rounded-lg p-3 ${card.color}` }> */}
                        {/* <p className={`border rounded-lg p-3 ${card.color}`}>
                          {card.icon}
                        </p>
                        <div>
                          <h2 className="mb-2 text-sm font-bold tracking-tight text-gray-500">
                            {card.title}
                          </h2>
                          <p className="text-2xl font-bold text-gray-700 mt-2">
                            {card.count}
                          </p>
                        </div>
                      </div>
                      <p className="mt-8">
                        <ChevronRight />
                      </p>
                    </div>
                  </div>
                ))}
            </div> */} 

            {/* Charts Section */}
            <div className="flex flex-wrap justify-center gap-6 mt-10">
              {/* Line Chart */}
              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <Linesales />
              </div>

              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <SalesDiscountComboChart />
              </div>
            </div>


            <div className="flex flex-wrap justify-center gap-6 mt-10">
              {/* Line Chart */}
              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <SalesVsAverageChart />
              </div>

              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <SpeedCompositionChartWithCalculations />
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-6 mt-10">
              {/* Line Chart */}
              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <DailyAverageSpeedChart />
              </div>

              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <CostAnalysisChart />
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-6 mt-10">
              {/* Line Chart */}
              {/* <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <EmployeeKpiScorecards />
              </div>

              <div className="w-full md:w-[48%] flex flex-col justify-center p-4 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <EmployeeHoursTrendChart />
              </div> */}

              <EmployeePerformanceDashboard />
            </div>

            {/* <div className="flex flex-wrap justify-center gap-6 mt-1">
              Pie Chart
              <div className="w-full md:w-[48%] flex flex-col justify-center p-2 bg-[#FAFDFF] border border-gray-200 rounded-2xl shadow-lg">
                <p className="text-2xl text-gray-800 text-center mb-4">
                  Ticket Status
                </p>
                <Chart
                  chartType="PieChart"
                  data={data1}
                  options={options1}
                  width={"100%"}
                  height={"600px"}
                />
              </div>
            </div> */}

          </>
        )}




        {/* <ChartDashboard /> */}




        <div>

        </div>
      </div>

    </div>
  );
};

export default Dashboard;
